// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mVGK","col":"styles_col__1eBRm","actions":"styles_actions__1Yore","conflict":"styles_conflict__3Ssvq"};